import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

const THEME_VERSION = 'v3';

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const version = localStorage.getItem('theme_version');
    if (version === THEME_VERSION) {
      return localStorage.getItem('theme') || 'light';
    }
    // First time with new version — force light
    localStorage.setItem('theme_version', THEME_VERSION);
    localStorage.setItem('theme', 'light');
    return 'light';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
